export const API = 'https://eevateam.com/';